import { RootStore } from './rootStore';
import {action, computed, decorate, observable} from 'mobx';
import { SystemStatusDto } from './models/accountStoreModels';
import api from 'src/utils/api';
import Helper from '../helper/helper';

export class AccountStore {
    accountsSyncStatus: SystemStatusDto[] | undefined;
    selectedAccountLastUpdatedDate: string | undefined;

    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    async getAccountsSyncStatus() {
        this.accountsSyncStatus = undefined;
        if(!this.rootStore.userStore.isUserPresent){
            return;
        }

        const response = await api.get<SystemStatusDto[]>(`account/GetAccountsSyncStatus`, {

        });

        if(!api.responseOk(response)) {
            return;
        }

        this.accountsSyncStatus = response.data;
    }

    get oldestAccountUpdatedDate() {
        if(!this.accountsSyncStatus){
            return "";
        }
        let updateDates:any = this.accountsSyncStatus.flatMap(x => x.accounts).flatMap(x => x.lastUpdateDate);
        if(updateDates.length === 0) return "";
        let min:Date = new Date();
        updateDates.forEach((v: Date) =>  min = new Date(v) < new Date(min)? v: min );

        return min;
    }

    get oldestADUpdatedDate() {
        if(!this.accountsSyncStatus){
            return "";
        }
        let updateDates:any = this.accountsSyncStatus.filter(x => x.name === 'AD').flatMap(x => x.accounts).flatMap(x => x.lastUpdateDate);
        if(updateDates.length === 0) return "";
        let min:Date = new Date();
        updateDates.forEach((v: Date) =>  min = new Date(v) < new Date(min)? v: min );

        return min;
    }

    get oldestGCPUpdatedDate() {
        if(!this.accountsSyncStatus){
            return "";
        }
        let updateDates:any = this.accountsSyncStatus.filter(x => x.name === 'GCP').flatMap(x => x.accounts).flatMap(x => x.lastUpdateDate);
        if(updateDates.length === 0) return "";
        let min:Date = new Date();
        updateDates.forEach((v: Date) =>  min = new Date(v) < new Date(min)? v: min );

        return min;
    }

    async getUpdatedDateBySelectedAccount() {
        this.selectedAccountLastUpdatedDate = '';
        if(!this.accountsSyncStatus){
            await this.getAccountLastUpdatedDateByName(this.rootStore.qarStore.currentlySelectedAccountForReview.id);
            return;
        }
        let updateDates:any = this.accountsSyncStatus.flatMap(x => x.accounts)
            .filter(x => x.id === this.rootStore.qarStore.currentlySelectedAccountForReview.id)
            .flatMap(x => x.lastUpdateDate);
        if(updateDates.length === 0){
            await this.getAccountLastUpdatedDateByName(this.rootStore.qarStore.currentlySelectedAccountForReview.id);
            return;
        }
        let min:Date = new Date();
        updateDates.forEach((v: Date) =>  min = new Date(v) < new Date(min)? v: min );

        this.selectedAccountLastUpdatedDate = min.toString();
    }

    async getAccountLastUpdatedDateByName(accountId:string) {
        this.selectedAccountLastUpdatedDate = '';
        const response = await api.get<string>(`account/GetAccountLastUpdatedDate`, {
            params: {
                accountId: accountId
            }
        });

        if(!api.responseOk(response)) {
            this.selectedAccountLastUpdatedDate = '';
        }

        this.selectedAccountLastUpdatedDate = new Date(response.data).toString();
    }
}

decorate(AccountStore,
    {
        accountsSyncStatus: observable,
        getAccountsSyncStatus: action,
        oldestAccountUpdatedDate: computed,
        oldestADUpdatedDate: computed,
        oldestGCPUpdatedDate: computed,
        getUpdatedDateBySelectedAccount: action,
        getAccountLastUpdatedDateByName: action,
        selectedAccountLastUpdatedDate: observable
    })